import * as z$1 from "zod/v4";
//#region src/official-cli-skill.ts
const OFFICIAL_CLI_SKILL_CONTRACT = "openmeld-skills-contract-2026-09-explicit-space-recipients-v1";
const OFFICIAL_CLI_SKILL_URL = "https://openmeld.ai/skills/openmeld-cli/SKILL.md";
const OFFICIAL_CLI_SKILL_MAX_BYTES = 1048576;
const OFFICIAL_CLI_SKILL_PUBLIC_KEY = `-----BEGIN PUBLIC KEY-----
MCowBQYDK2VwAyEAFZjFHrQ/QLsJQpHkAbKBRG57fEazhm7zc0dMa54ilWQ=
-----END PUBLIC KEY-----
`;
const officialCliSkillPayloadSchema = z$1.object({
	schemaVersion: z$1.literal(1),
	revision: z$1.number().int().positive(),
	minimumCliVersion: z$1.string().regex(/^\d+\.\d+\.\d+$/),
	contractVersion: z$1.string().min(1).max(128),
	files: z$1.array(z$1.object({
		path: z$1.string().regex(/^(?:SKILL\.md|(?:playbooks|references)\/[a-z0-9-]+\.md)$/),
		content: z$1.string().min(1).max(131072)
	}).strict()).min(1).max(32)
}).strict().superRefine((value, context) => {
	const paths = value.files.map((file) => file.path);
	if (!paths.includes("SKILL.md") || new Set(paths).size !== paths.length) context.addIssue({
		code: "custom",
		message: "Skill entry is required and paths must be unique"
	});
});
const officialCliSkillReleaseSchema = z$1.object({
	payload: z$1.string().min(1).max(524288),
	signature: z$1.string().regex(/^[A-Za-z0-9+/]{86}==$/)
}).strict();
const officialCliSkillChannelSchema = z$1.object({
	schemaVersion: z$1.literal(1),
	releases: z$1.array(officialCliSkillReleaseSchema).min(1).max(16)
}).strict();
//#endregion
export { OFFICIAL_CLI_SKILL_CONTRACT, OFFICIAL_CLI_SKILL_MAX_BYTES, OFFICIAL_CLI_SKILL_PUBLIC_KEY, OFFICIAL_CLI_SKILL_URL, officialCliSkillChannelSchema, officialCliSkillPayloadSchema, officialCliSkillReleaseSchema };

//# sourceMappingURL=official-cli-skill.js.map